import { api } from '@/api/api';
import { apis } from '@/config';
import { TEAM_EVENT_NAME } from '@/api/logical/im_team';
import { writeOrgsToLoki, writeOrgContactsToLoki, deleteOrgContactsByOrgId } from './contact_sync_enterprise_loki';
import { contactSearchDbName, contactDbName } from './util/const';
export class ContactIMHelper {
    constructor(teamModule) {
        this.teamModule = teamModule;
    }
    getLokiApi() {
        return api.requireLogicalApi(apis.dbMemoryApiImpl);
    }
    getDexieApi() {
        return api.requireLogicalApi(apis.dexieDbApi);
    }
    async dexiePutOrgs(orgList, _account) {
        this.getDexieApi()
            .putAll({ dbName: contactDbName, tableName: 'org', _dbAccount: _account }, orgList)
            .catch(e => console.warn('[contact_im_helper] dexiePutOrgs error', e));
    }
    async dexiePutOrgContacts(orgContactList, _account) {
        this.getDexieApi()
            .putAll({ dbName: contactDbName, tableName: 'orgContact', _dbAccount: _account }, orgContactList)
            .catch(e => console.warn('[contact_im_helper] dexiePutOrgContacts error', e));
    }
    async dexieDeleteOrgById(orgId, _account) {
        this.getDexieApi()
            .deleteById({ dbName: contactDbName, tableName: 'org' }, orgId, _account)
            .catch(e => console.warn('[contact_im_helper] dexieDeleteOrgById error', e));
    }
    async dexieDeleteOrgContactsByOrgId(orgId, _account) {
        this.getDexieApi()
            .deleteByByRangeCondition({
            dbName: contactDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'startsWith',
                field: 'id',
                args: [orgId],
            },
            _dbAccount: _account,
        }, _account)
            .catch(e => console.warn('[contact_im_helper] dexieDeleteOrgContactsByOrgId error', e));
    }
    async dexieDeleteOrgContactsByImIds(imIdList, _account) {
        this.getDexieApi()
            .deleteByByRangeCondition({
            dbName: contactDbName,
            tableName: 'orgContact',
            adCondition: {
                type: 'anyOf',
                field: 'imId',
                args: [imIdList],
            },
            _dbAccount: _account,
        }, _account)
            .catch(e => console.warn('[contact_im_helper] dexieDeleteOrgContactsByImIds error', e));
    }
    async checkNeedFullSync(_account) {
        const lokiApi = this.getLokiApi();
        const result = await lokiApi
            .getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: 'org',
            adCondition: {
                type: 'startsWith',
                field: 'id',
                args: ['team_'],
            },
            _dbAccount: _account,
        })
            .catch(() => []);
        return !result || result.length === 0;
    }
    async backfillTeamsFromDexie(_account) {
        try {
            const dexieApi = this.getDexieApi();
            const lokiApi = this.getLokiApi();
            const teamOrgs = await dexieApi.getByRangeCondition({
                dbName: contactDbName,
                tableName: 'org',
                adCondition: {
                    type: 'equals',
                    field: 'type',
                    args: [2000],
                },
                _dbAccount: _account,
            });
            if (!teamOrgs || teamOrgs.length === 0) {
                return false;
            }
            await writeOrgsToLoki(lokiApi, teamOrgs, _account || '');
            const teamOrgContacts = await dexieApi.getByRangeCondition({
                dbName: contactDbName,
                tableName: 'orgContact',
                adCondition: {
                    type: 'startsWith',
                    field: 'orgId',
                    args: ['team_'],
                },
                _dbAccount: _account,
            });
            if (teamOrgContacts && teamOrgContacts.length > 0) {
                await writeOrgContactsToLoki(lokiApi, teamOrgContacts, _account || '');
            }
            console.warn('[contact_im_helper] backfillTeamsFromDexie success, orgs:', teamOrgs.length, 'contacts:', (teamOrgContacts === null || teamOrgContacts === void 0 ? void 0 : teamOrgContacts.length) || 0);
            return true;
        }
        catch (e) {
            console.error('[contact_im_helper] backfillTeamsFromDexie error', e);
            return false;
        }
    }
    async syncAllTeams(_account) {
        const lokiApi = this.getLokiApi();
        try {
            const serverData = await this.teamModule.getTeamServerData();
            if (!serverData.teamList.length) {
                return;
            }
            const teamOrgList = this.teamModule.transTeamToOrg(serverData.teamList);
            await lokiApi.deleteByByRangeCondition({
                dbName: contactSearchDbName,
                tableName: 'org',
                adCondition: {
                    type: 'equals',
                    field: 'type',
                    args: [2000],
                },
                _dbAccount: _account,
            });
            await writeOrgsToLoki(lokiApi, teamOrgList, _account || '');
            this.dexiePutOrgs(teamOrgList, _account || '');
            const allTeamIds = teamOrgList.map(t => t.id.replace('team_', ''));
            if (allTeamIds.length) {
                const allMemberList = allTeamIds.flatMap(teamId => {
                    const members = serverData.teamMemberMap[teamId] || [];
                    return members;
                });
                if (allMemberList.length) {
                    const orgContactList = await this.teamModule.transTeamMemberToOrgContact(allMemberList);
                    await writeOrgContactsToLoki(lokiApi, orgContactList, _account || '');
                    this.dexiePutOrgContacts(orgContactList, _account || '');
                }
            }
        }
        catch (e) {
            console.error('[contact_im_helper] syncAllTeams error', e);
        }
    }
    async handleTeamEvent(res, sendContactNotify) {
        const lokiApi = this.getLokiApi();
        const mainAccount = '';
        const { action, team, accounts } = res;
        try {
            switch (action) {
                case TEAM_EVENT_NAME.UPDATE_TEAM: {
                    if (team) {
                        const teamOrgList = this.teamModule.transTeamToOrg([team]);
                        await writeOrgsToLoki(lokiApi, teamOrgList, mainAccount);
                        this.dexiePutOrgs(teamOrgList, mainAccount);
                    }
                    else {
                        console.warn('[contact_im_helper] UPDATE_TEAM no data');
                    }
                    break;
                }
                case TEAM_EVENT_NAME.LEAVE_TEAM: {
                    if (team) {
                        const orgId = 'team_' + team.teamId;
                        await deleteOrgContactsByOrgId(lokiApi, orgId, mainAccount);
                        this.dexieDeleteOrgContactsByOrgId(orgId, mainAccount);
                        await lokiApi.deleteById({ dbName: contactSearchDbName, tableName: 'org' }, orgId, mainAccount);
                        this.dexieDeleteOrgById(orgId, mainAccount);
                    }
                    else {
                        console.warn('[contact_im_helper] LEAVE_TEAM no data');
                    }
                    break;
                }
                case TEAM_EVENT_NAME.ADD_TEAM_MEMBERS: {
                    if (team && (accounts === null || accounts === void 0 ? void 0 : accounts.length)) {
                        const teamMemberList = await this.teamModule.getTeamMemberByTeamIdAndAccount(team.teamId, accounts);
                        const orgContactList = await this.teamModule.transTeamMemberToOrgContact(teamMemberList);
                        await writeOrgContactsToLoki(lokiApi, orgContactList, mainAccount);
                        this.dexiePutOrgContacts(orgContactList, mainAccount);
                        const teamOrgList = this.teamModule.transTeamToOrg([team]);
                        await writeOrgsToLoki(lokiApi, teamOrgList, mainAccount);
                        this.dexiePutOrgs(teamOrgList, mainAccount);
                    }
                    else {
                        console.warn('[contact_im_helper] ADD_TEAM_MEMBERS no data');
                    }
                    break;
                }
                case TEAM_EVENT_NAME.REMOVE_TEAM_MEMBERS: {
                    if (team && (accounts === null || accounts === void 0 ? void 0 : accounts.length)) {
                        const orgId = 'team_' + team.teamId;
                        const imIdList = accounts.map(acc => `${orgId}_${acc}`);
                        await lokiApi.deleteByByRangeCondition({
                            dbName: contactSearchDbName,
                            tableName: 'orgContact',
                            adCondition: {
                                type: 'anyOf',
                                field: 'imId',
                                args: [imIdList],
                            },
                            _dbAccount: mainAccount,
                        });
                        this.dexieDeleteOrgContactsByImIds(imIdList, mainAccount);
                        const teamOrgList = this.teamModule.transTeamToOrg([team]);
                        await writeOrgsToLoki(lokiApi, teamOrgList, mainAccount);
                        this.dexiePutOrgs(teamOrgList, mainAccount);
                    }
                    else {
                        console.warn('[contact_im_helper] REMOVE_TEAM_MEMBERS no data');
                    }
                    break;
                }
                case TEAM_EVENT_NAME.JOIN_TEAM: {
                    if (team) {
                        const teamOrgList = this.teamModule.transTeamToOrg([team]);
                        const teamId = team.teamId;
                        await writeOrgsToLoki(lokiApi, teamOrgList, mainAccount);
                        this.dexiePutOrgs(teamOrgList, mainAccount);
                        const teamMemberList = await this.teamModule.getTeamMemberById([teamId]);
                        if (teamMemberList.length) {
                            const orgContactList = await this.teamModule.transTeamMemberToOrgContact(teamMemberList);
                            await writeOrgContactsToLoki(lokiApi, orgContactList, mainAccount);
                            this.dexiePutOrgContacts(orgContactList, mainAccount);
                        }
                    }
                    else {
                        console.warn('[contact_im_helper] JOIN_TEAM no data');
                    }
                    break;
                }
                case TEAM_EVENT_NAME.TRANSFER_TEAM: {
                    if (team && accounts) {
                        const teamMemberList = await this.teamModule.getTeamMemberByTeamIdAndAccount(team.teamId, accounts);
                        const orgContactList = await this.teamModule.transTeamMemberToOrgContact(teamMemberList);
                        await writeOrgContactsToLoki(lokiApi, orgContactList, mainAccount);
                        this.dexiePutOrgContacts(orgContactList, mainAccount);
                        const teamOrgList = this.teamModule.transTeamToOrg([team]);
                        await writeOrgsToLoki(lokiApi, teamOrgList, mainAccount);
                        this.dexiePutOrgs(teamOrgList, mainAccount);
                    }
                    else {
                        console.warn('[contact_im_helper] TRANSFER_TEAM no data');
                    }
                    break;
                }
                default:
                    break;
            }
        }
        catch (e) {
            console.error('[contact_im_helper] handleTeamEvent error', action, e);
        }
        sendContactNotify({ syncStatus: { team: true } });
    }
}
let _instance = null;
export const setContactIMHelperInstance = (instance) => {
    _instance = instance;
};
export const getContactIMHelperInstance = () => {
    if (!_instance) {
        throw new Error('[contact_im_helper] ContactIMHelper not initialized');
    }
    return _instance;
};
export const ContactIMHelperInstance = {
    get instance() {
        return getContactIMHelperInstance();
    },
};
